module.exports = __webpack_public_path__ + "static/westbengal-logo-0c5610b9d342009d3d4571b229dd78d9.png";